import { forEach, cloneDeep, clone } from 'lodash'

export default {
  setTimeFrame (state, timeFrame) {
    if (timeFrame) {
      state.startDate = clone(timeFrame.startDate)
      state.endDate = clone(timeFrame.endDate)
      // forEach(timeFrame.selectedTimeFrame, (value, key) => {
      //   if (value) {
      //     Vue.set(state.selectedTimeFrame, key, value)
      //   } else {
      //     state.selectedTimeFrame[key] = value
      //   }
      // })
      state.selectedTimeFrame = cloneDeep(timeFrame.selectedTimeFrame)
    } else {
      state.startDate = null
      state.endDate = null
      state.selectedTimeFrame = {}
    }
  },
  setApplied (state, status) {
    state.applied = status
  },
  setApplicable (state, status) {
    state.applicable = status
  },
  setTimeFrames (state, timeFrames) {
    state.timeFrames = timeFrames
  },
  setStartDate (state, startDate) {
    state.startDate = startDate
  },
  setEndDate (state, endDate) {
    state.endDate = endDate
  },
  setSelectedTimeFrame (state, timeFrame) {
    forEach(timeFrame, (value, key) => {
      if (value) {
        state.selectedTimeFrame[key] = value
      } else {
        state.selectedTimeFrame[key] = value
      }
    })
  },
  clearSelectedTimeFrame (state) {
    state.selectedTimeFrame = {}
    state.startDate = null
    state.endDate = null
  },
  clear (state) {
    state.applied = false
    state.startDate = null
    state.endDate = null
    state.timeFrames = []
    state.selectedTimeFrame = {}
  },
  setCachedTimeFrame(state, frame) {
    state.cachedTimeFrame = frame
  },
  clearCachedTimeFrame(state) {
    state.cachedTimeFrame = null
  }
}
